import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_PRICE_LIST_TARIFF_COLLECTION_NAME = "price-list-tariff";

export const useRxCollectionPriceListTariff =
  (): RxCollection<PriceListTariff> | null =>
    useRxCollection<PriceListTariff>(RXDB_PRICE_LIST_TARIFF_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<PriceListTariff>>;
export type PriceListTariffQueryConstructor = UseRxData["1"];

const PRICE_LIST_TARIFF_SCHEMA_LITERAL = {
  title: "price list tariff schema",
  version: 1,
  description: "A tariff (e.g. payer / pricing scheme) used by prices",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    name: {
      type: "string",
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "name", "meta"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(PRICE_LIST_TARIFF_SCHEMA_LITERAL);

export type PriceListTariff = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const PRICE_LIST_TARIFF_SCHEMA: RxJsonSchema<PriceListTariff> =
  PRICE_LIST_TARIFF_SCHEMA_LITERAL;
